import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CartItemContainersModule } from "src/app/ui-widgets/cart-item-containers/cart-item-containers.module";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { ModulesContainerModule } from "src/app/ui-widgets/modules-container/modules.container.module";
import { ProductFiltersModule } from "src/app/ui-widgets/product-filters/product-filters.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { CartComponent } from "./cart.component";
import { CartRoutingModule } from "./cart-routing.module";

@NgModule({
    imports: [
        RouterModule,
        ProductFiltersModule,
        CommonModule,
        HeaderModule,
        SidebarModule,
        CartItemContainersModule,
        ModulesContainerModule,
        CartRoutingModule
    ],
    declarations: [
        CartComponent
    ]
  })
  export class CartModule { }
